import React, { useEffect, useReducer, useState } from 'react'
import '../assests/style.css';
import { Row, Col } from 'antd';
import { initialState, reducer } from "./reducer";
import SocialNewsList from './components/List';
import 'antd/dist/antd.css';
import ConsultNewsComponent from './components/Consult';
import Search from './components/Search';
import NewsService from '../../services/Election/NewsService';
import SimpleHeader from '../../helpers/cards-helper/SimpleHeader';



const MemberNews = () => {
    const [state, dispatch] = useReducer(reducer, initialState);
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        setLoading(true);
        NewsService.getNewsList(state.filters)
            .then((response) => {
                let index = 0;
                const itemsList = response.data.map((elm) => {
                    index += 1;
                    return {
                        ...elm,
                        index: index
                    }
                });
                const action = {
                    type: "set_items",
                    payload: {
                        items: itemsList,
                        total: response.data.length
                    },
                };
                dispatch(action);
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
            });
    }, [state.filters]);


    const updateIndexVisibility = (indexVisibility) => {
        const action = {
            type: "set_index_visibility",
            payload: indexVisibility,
        };
        dispatch(action);
    };


    const refreshList = () => {
        const action = {
            type: "refresh_list",
        };
        dispatch(action);
    };


    const changeVisibility = (elm) => {
        const action = {
            type: "set_elm",
            payload: elm,
        };
        dispatch(action);
    };


    return (
        <Row gutter={24} className="page-content">
            <Col span={24}>

                {state.indexVisibility === 0 && (
                    <Row gutter={24}>
                        <Col span={24}>
                            <SimpleHeader
                                title={"Lajme"}
                            />
                        </Col>
                    </Row>
                )}

                {state.indexVisibility === 0 && (
                    <Row gutter={24} className="mt-2">
                        <Col span={24}>
                            <Search
                                dispatch={dispatch}
                                initialFilters={state.filters.searchFilters}
                            />
                        </Col>
                    </Row>
                )}

                {state.indexVisibility === 0 && (
                    <Row gutter={24}>
                        <Col span={24}>
                            <SocialNewsList
                                is_clicked={state.is_clicked}
                                dispatch={dispatch}
                                items={state.items}
                                totalCount={state.totalCount}
                                filters={state.filters}
                                isLoading={loading}
                                onRefreshList={() => refreshList()}
                                initialPagination={state.filters.pagination}
                                onChangeIndexVisibility={changeVisibility}
                            />
                        </Col>
                    </Row>
                )}

                {state.indexVisibility === 1 && (
                    <Row gutter={24}>
                        <Col span={24}>
                            <ConsultNewsComponent
                                dispatch={dispatch}
                                items={state.items}
                                item={state.itemSelected}
                                changeIndexVisibility={updateIndexVisibility}
                            />
                        </Col>
                    </Row>
                )}

            </Col>
        </Row>
    );
};


export default MemberNews;